import axios from "axios";

const api = axios.create({
  baseURL: "https://api.painel.manyflows.app",
  // baseURL: "http://localhost:3334",
});

export default api;
